<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Iconos
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
          v-card-title(style='padding: 8px !important;').justify-center
            img(src='../assets/logo.png', style='height: auto;width: 80px;border-radius:5px')
        v-card(color='', style="border-radius:5px;background-color: black")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text  Administración de Movimientos Bancarios
    v-dialog(v-model='dialog', persistent max-width='700px')
      v-btn.mb-2(v-if='cre' slot='activator', style="border-radius:5px;background-color:#fe0100;") Subir Excel
      v-container(style='background-color:white !important;max-width: 700px;')
        v-card-title.justify-center
          span.headline Subir movimientos
        div(style="margin-top: 20px;")
          v-flex(xs12, sm12, md12)
            v-layout(align-start='', justify-center='', row='', wrap fill-height='')
              v-flex(xs12, md8)
                v-form(enctype="multipart/form-data")

                  v-text-field(outline label='Selecciona un archivo (Excel o TXT/CSV)', @click='pickFile' prepend-inner-icon='attach_file' :value="selectedFileName")
                  input(
                    type="file"
                    style="display: none"
                    ref="file"
                    accept='.xlsx, .xls, .txt, .csv'
                    @change="onFileChange")

                  v-select(v-if="esTxt && !esMT940" outline :items='delimitadores' v-model="delimitador" item-text="text" item-value="value" prepend-inner-icon="call_split" label="Delimitador:" @change="reparsearTxt")

                  div(v-if="esMT940 && data.length > 0" style="margin-bottom:12px;")
                    p(style="font-weight:600;margin:8px 0 4px;font-size:13px;color:#1565C0;") ✓ Formato detectado — {{ data.length }} transacciones
                    div(style="overflow-x:auto;max-height:400px;overflow-y:auto;border:1px solid #90CAF9;border-radius:4px;")
                      table(style="width:100%;border-collapse:collapse;font-size:11px;")
                        thead
                          tr(style="background:#E3F2FD;font-weight:600;position:sticky;top:0;z-index:1;")
                            td(style="border:1px solid #BBDEFB;padding:3px 8px;") Fecha
                            td(style="border:1px solid #BBDEFB;padding:3px 8px;") Descripción
                            td(style="border:1px solid #BBDEFB;padding:3px 8px;") Monto
                            td(style="border:1px solid #BBDEFB;padding:3px 8px;") Referencia
                        tbody
                          tr(v-for="(row, ri) in data" :key="ri" :style="ri%2===0 ? 'background:#fafafa;' : ''")
                            td(style="border:1px solid #e0e0e0;padding:3px 8px;") {{ row.fecha }}
                            td(style="border:1px solid #e0e0e0;padding:3px 8px;") {{ row.descripcion }}
                            td(:style="'border:1px solid #e0e0e0;padding:3px 8px;color:' + (row.monto < 0 ? '#c62828' : '#2e7d32')") {{ formatMiles(row.monto) }}
                            td(style="border:1px solid #e0e0e0;padding:3px 8px;") {{ row.referencia }}

                  div(v-if="esMT940 && data.length === 0" style="margin-bottom:12px;padding:10px;background:#FFF3E0;border:1px solid #FFB74D;border-radius:4px;")
                    p(style="font-weight:600;margin:0 0 6px;font-size:13px;color:#E65100;") ⚠ Se detectó el formato pero no se encontraron créditos (CREDIT) para procesar. Verifique que el archivo tenga movimientos de tipo CREDIT.
                    div(v-if="chaseDebug" style="font-size:11px;font-family:monospace;background:#fff;border:1px solid #FFCC80;border-radius:4px;padding:8px;overflow-x:auto;")
                      div Header crudo: {{ chaseDebug.headerRaw }}
                      div Columnas header: {{ chaseDebug.header }}
                      div Índices → Details:{{ chaseDebug.idxDetails }} Fecha:{{ chaseDebug.idxFecha }} Desc:{{ chaseDebug.idxDesc }} Monto:{{ chaseDebug.idxMonto }}
                      div Total líneas: {{ chaseDebug.totalLineas }}
                      div(v-for="(fila, fi) in chaseDebug.primerasFilas" :key="fi") Fila {{ fi+1 }} ({{ fila.length }} cols): {{ fila }}

                  div(v-if="!esMT940 && rawRows.length > 0" style="margin-bottom:12px;")
                    v-checkbox(v-model="primeraFilaEncabezado" label="Primera fila como encabezado" hide-details @change="actualizarColumnas" style="margin-top:0;margin-bottom:8px;")
                    p(style="font-weight:600;margin:8px 0 4px;font-size:13px;") Vista previa
                    div(style="overflow-x:auto;max-height:150px;overflow-y:auto;border:1px solid #ddd;border-radius:4px;margin-bottom:12px;")
                      table(style="width:100%;border-collapse:collapse;font-size:11px;")
                        tbody
                          tr(v-for="(row, ri) in preview" :key="ri" :style="ri===0 && primeraFilaEncabezado ? 'background:#f0f0f0;font-weight:600;' : (ri%2===0 ? 'background:#fafafa;' : '')")
                            td(v-for="(cell, ci) in row" :key="ci" style="border:1px solid #e0e0e0;padding:3px 8px;white-space:nowrap;") {{ cell }}
                    p(style="font-weight:600;margin:8px 0 4px;font-size:13px;") Mapear columnas
                    v-select(outline :items='columnasOpciones' item-text="text" item-value="value" v-model="mapeo.fecha" prepend-inner-icon="event" label="Columna → Fecha" hide-details style="margin-bottom:8px;")
                    v-select(outline :items='columnasOpciones' item-text="text" item-value="value" v-model="mapeo.descripcion" prepend-inner-icon="notes" label="Columna → Descripción" hide-details style="margin-bottom:8px;")
                    v-select(outline :items='columnasOpciones' item-text="text" item-value="value" v-model="mapeo.monto" prepend-inner-icon="attach_money" label="Columna → Monto" hide-details style="margin-bottom:8px;")
                    v-select(outline :items='columnasOpciones' item-text="text" item-value="value" v-model="mapeo.referencia" prepend-inner-icon="label" label="Columna → Referencia (opcional)" hide-details style="margin-bottom:8px;")

                  v-select(outline
                  :items='bancos'
                  v-model="banco"
                  prepend-inner-icon="description"
                  label="Bancos:")

                  div
                    v-flex(v-if="loading === true", xs12 sm12 md12)
                      v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                        v-progress-circular(indeterminate='', color='primary')
                    v-flex(v-if="loading === false", xs12 sm12 md12)
                      v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                          v-btn(style="background:green;border-radius:10px;", @click.native='save()') Procesar
                          v-btn(style="background:black;border-radius:10px;", @click.native='close') Salir
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-flex(xs12 style='margin-top: 5px;')
          v-layout(wrap style='justify-content: space-between;')
            v-flex(xs3)
              v-text-field(v-model='search', label='Buscar')
            v-flex(xs3 style='display: flex;justify-content: center;padding-left:20px;')
              v-select(:disabled="resultadosres.length == 0" :items='filtros' v-model="seleccionFiltro" label="Estatus" @change='cambiarFiltro()')
            v-flex(xs3 style='display: flex;justify-content: center;padding-left:20px;')
              v-select(:disabled="resultadosres.length == 0" :items='bancosF' v-model="seleccionFiltroB" label="Bancos" @change='cambiarFiltroB()')
            v-flex(xs2 style='display: flex;align-items: center;justify-content: flex-end;')
              v-menu(ref='menu1' v-model='modal' :close-on-content-click='false' transition='scale-transition' offset-y='' max-width='450px' min-width='450px')
                template(v-slot:activator='{ on, attrs }')
                  v-text-field(v-model='dateRangeText' label='Fecha' style='padding-left: 15px;' persistent-hint='' v-bind='attrs' v-on='on')
                v-date-picker(multiple v-model='dates' no-title='' dark='')
                  v-spacer
                  v-btn(text='' color='primary' @click='$refs.menu1.save(dates)')
                    | OK
              v-btn.mx-0(icon @click='buscarFecha' style='background: white;border-radius: 100%;margin-left:10px !important;').elevation-4
                v-icon(color='#fe0100' style='font-size: 1.70rem;') search
            v-flex(xs1 style='display: flex;align-items: center;justify-content: center;')
              vue-excel-xlsx( v-if='resultados && resultados.length > 0' :data='dataExcel' :columns='columnsExcel' :filename="'Fercoven-Movimientos'" :sheetname="'sheetname'")
                div(style='display: flex;flex-direction: column;font-size: 12px;font-weight: bold;text-align: center;')
                  img(src='../assets/iconos/excel.png', style='height: 60px;width: auto;')
                  span Movimientos
        v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
          v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
            span.white--text Lista de Movimientos
        v-data-table.elevation-1(:headers='headers' :pagination.sync="pagination" :search='search' :items="resultados" style="margin-top: 5px;")
          template(slot='items', slot-scope='props')
            td {{ transform(props.item.fechaC)}}
            td {{ transform(props.item.fecha)}}
            td {{ props.item.descripcion }}
            td {{ props.item.banco }}
            td {{ formatMiles(props.item.monto) }}
            td {{ props.item.referencia }}
            td {{ props.item.estatus }}
            td(v-if='props.item.cobro && props.item.cobro.nro') {{ props.item.cobro.nro }}
            td(v-else) N/A
            td
              v-btn.mx-0(v-if='elm && props.item.estatus == "Pendiente"' icon, @click='deleteItem(props.item)')
                  v-icon(color='pink') delete
  //===========================================================Modal Espera==============================================================================================
  v-dialog(v-model='dialog4', persistent max-width='400px' style='background:#f1f2f1')
    v-container(style='max-width: 400px;background:#f1f2f1')
      div(style="margin-top: 20px;")
          v-flex(xs12 sm12)
            v-layout(align-start='', justify-center='', row='', wrap fill-height='')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h4.black--text  Esperando Respuesta del Servidor.!!
              v-flex(xs12)
                  div(style='display: flex;justify-content: center;').text-xs-center
                    img(src='../assets/waiting.gif', with='200' ,height='150')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h5.black--text  Por favor espere...
</template>

<script>
import readXlsxFile from 'read-excel-file'
import Api from "@/services/methods";
import { serverImg } from "@/services/environment";
export default {
  name: "Movimientos",
  data: vm => ({
    ruta: serverImg,
    dates: [],
    data: [],
    dataExcel: [],
    columnsExcel: [
      {
        label: "Fecha Creación",
        field: "fechaC",
      },
      {
        label: "Fecha Movimiento",
        field: "fecha",
      },
      {
        label: "Cobro",
        field: "nro",
      },
      {
        label: "Descripcion",
        field: "descripcion",
      },
      {
        label: "Banco",
        field: "banco",
      },
      {
        label: "Monto",
        field: "monto",
      },
      {
        label: "Referencia",
        field: "referencia",
      },
      {
        label: "Estatus",
        field: "estatus",
      },
    ],
    loading: false,
    dialog4: false,
    selectedFileName: null,
    bancos: [],
    bancosF: ["Todos"],
    banco: "",
    seleccionFiltro: 'todos',
    seleccionFiltroB: 'Todos',
    filtros: [
      {
        text: "Todos",
        value: "todos"
      },
      {
        text: "Pendientes",
        value: "Pendiente"
      },
      {
        text: "Conciliados",
        value: "Conciliado"
      },
    ],
    pagination: {
      sortBy: 'fecha', // The field that you're sorting by
      descending: true
    },
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    modal: false,
    search: "",
    form: {
      _id: "",
      fecha: "",
      descripcion: "",
      banco: "",
      monto: "",
      referencia: "",
      estatus: ""
    },
    dialog: false,
    resultadosres: [],
    resultados: [],
    headers: [
      { text: "Fecha Creación", value: "fechaC" },
      { text: "Fecha Movimiento", value: "fecha" },
      { text: "Descripción", value: "descripcion" },
      { text: "Banco", value: "banco" },
      { text: "Monto", value: "monto" },
      { text: "Referencia", value: "referencia" },
      { text: "Estatus", value: "estatus" },
      { text: "Cobro", value: "cobro.nro" },
      { text: "Acciones" },
    ],
    defaultForm: {
      _id: "",
      fecha: "",
      descripcion: "",
      banco: "",
      monto: "",
      referencia: "",
      estatus: ""
    },
    cre: "",
    mod: "",
    elm: "",
    img: "",
    rawRows: [],
    preview: [],
    columnasOpciones: [],
    mapeo: { fecha: null, descripcion: null, monto: null, referencia: null },
    esTxt: false,
    esMT940: false,
    chaseDebug: null,
    txtContenido: '',
    delimitador: ';',
    delimitadores: [
      { text: 'Punto y coma (;)', value: ';' },
      { text: 'Coma (,)', value: ',' },
      { text: 'Tabulación', value: '\t' },
      { text: 'Barra vertical (|)', value: '|' },
      { text: 'Espacio', value: ' ' },
    ],
    primeraFilaEncabezado: false
  }),
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    dateRangeText () {
      let todos = []
      let desde
      let hasta
      if (this.dates && this.dates[0])  {
        desde = this.formatDate(this.dates[0])
        todos.push(desde)
      }
      if (this.dates && this.dates[1]) {
        hasta = this.formatDate(this.dates[1])
        todos.push(hasta)
      }
      return todos.join(' ~ ')
    },
  },
  watch: {
    dates (val) {
      if (val && val.length > 2) {
        let res = []
        res.push(val[0])
        res.push(val[2])
        this.$nextTick(() => {
          this.dates = res
        })
      }
      if (val && val.length == 2 && val[0] > val[1]) {
        this.$swal.fire(
          "¡Atención!",
          "La fecha final debe ser mayor a la fecha inicial.",
          "error"
        );
        let res = []
        res.push(val[0])
        this.$nextTick(() => {
          this.dates = res
        })
      }
    },
    date () {
      this.dateFormatted = this.formatDate(this.date)
    },
  },
  created() {
    let desde = this.$moment().subtract(1, "d").format('YYYY-MM-DD')
    let hasta = this.$moment().format('YYYY-MM-DD')
    this.dates.push(desde)
    this.dates.push(hasta)
    this.verificacion();
    this.cargarBancos();
    this.initialize();
  },
  methods: {
    formatMiles(val) {
      if (val === null || val === undefined || val === '') return val;
      const num = parseFloat(val);
      if (isNaN(num)) return val;
      return num.toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    cargarBancos() {
      Api.get("metodopago/modulo?modulo=CobroApp")
        .then(res => {
          if (res.data && res.data.length > 0) {
            this.bancos = res.data.map(b => b.nombre)
            this.bancosF = ["Todos", ...res.data.map(b => b.nombre)]
          }
        })
        .catch(err => console.error("Error cargando bancos:", err))
    },
    deleteItem(item) {
      this.$swal
        .fire({
          title: "¿Estás seguro?",
          text: "No podrás revertir esta operación!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Si, Eliminar!"
        })
        .then(result => {
          if (result.value) {
            Api.delete("movimientos/" + item._id)
              .then(res => {
                this.$swal.fire(
                  "Felicidades.!",
                  "Eliminación realizada exitosamente.",
                  "success"
                );
                this.initialize();
              })
              .catch(err => {
                console.error(err);
              });
          }
        });
    },
    pickFile() {
      this.$refs.file.value = ''; // Resetear el input
      this.$refs.file.click();
    },
    onFileChange(event) {
      let file = event.target.files ? event.target.files[0] : null;
      if (!file) return;
      this.selectedFileName = file.name;
      this.rawRows = [];
      this.preview = [];
      this.columnasOpciones = [];
      this.mapeo = { fecha: null, descripcion: null, monto: null, referencia: null };
      this.data = [];
      this.chaseDebug = null;
      const ext = file.name.split('.').pop().toLowerCase();
      this.esTxt = ext === 'txt' || ext === 'csv';
      if (this.esTxt) {
        const reader = new FileReader();
        reader.onload = (e) => {
          // Quitar BOM (UTF-8 \uFEFF, o su versión mal-decodificada al leer como latin1 "ï»¿")
          // que de lo contrario rompe la comparación exacta de encabezados (p.ej. "Details"),
          // y normalizar saltos de línea (CRLF o CR-solo) a LF: si el archivo usa \r sin \n
          // (algunos exports bancarios/Mac), split(/\r?\n/) no separaría ninguna línea y
          // todo el contenido se trataría como una sola línea, dando 0 transacciones.
          const contenido = String(e.target.result || '')
            .replace(/^\uFEFF/, '')
            .replace(/^\u00EF\u00BB\u00BF/, '')
            .replace(/\r\n/g, '\n')
            .replace(/\r/g, '\n');
          if (this.detectarMT940(contenido)) {
            this.esMT940 = true;
            this.data = this.parsearMT940(contenido);
            this.rawRows = [];
          } else if (this.detectarCSVBancario(contenido)) {
            this.esMT940 = true;
            this.data = this.parsearCSVBancario(contenido);
            this.rawRows = [];
          } else if (this.detectarBanescoSemicolon(contenido)) {
            this.esMT940 = true;
            this.data = this.parsearBanescoSemicolon(contenido);
            this.rawRows = [];
          } else if (this.detectarChase(contenido)) {
            this.esMT940 = true;
            this.data = this.parsearChase(contenido);
            this.rawRows = [];
          } else {
            this.esMT940 = false;
            this.txtContenido = contenido;
            this.reparsearTxt();
          }
        };
        reader.readAsText(file, 'latin1');
      } else {
        readXlsxFile(file).then((rows) => {
          this.rawRows = rows.map(row => row.map(cell => (cell !== null && cell !== undefined) ? String(cell) : ''));
          this.actualizarColumnas();
        });
      }
    },
    reparsearTxt() {
      if (!this.txtContenido) return;
      const lineas = this.txtContenido.split(/\r?\n/).filter(l => l.trim());
      this.rawRows = lineas.map(l => l.split(this.delimitador).map(c => c.trim()));
      this.actualizarColumnas();
    },
    detectarMT940(contenido) {
      return contenido.includes('{4:') || /^:61:/m.test(contenido);
    },
    parsearMT940(contenido) {
      const transacciones = [];
      const lines = contenido.split(/\r?\n/);
      let currentTxn = null;
      for (const line of lines) {
        const l = line.trim();
        if (l.startsWith(':61:')) {
          if (currentTxn) transacciones.push(currentTxn);
          const raw = l.substring(4);
          // YYMMDD [MMDD] [R] C|D Amount Reference
          const match = raw.match(/^(\d{6})(?:\d{4})?R?([CD])([\d,]+)(.*)$/);
          if (match) {
            const ds = match[1];
            const tipo = match[2];
            const amt = parseFloat(parseFloat(match[3].replace(',', '.')).toFixed(2));
            const ref = match[4].trim();
            currentTxn = {
              fecha: `20${ds.substring(0,2)}-${ds.substring(2,4)}-${ds.substring(4,6)}`,
              descripcion: '',
              monto: tipo === 'D' ? -amt : amt,
              referencia: ref,
              estatus: 'Pendiente'
            };
          }
        } else if (l.startsWith(':86:') && currentTxn) {
          const desc = l.substring(4).trim();
          currentTxn.descripcion = currentTxn.descripcion
            ? currentTxn.descripcion + ' ' + desc
            : desc;
        } else if (l.startsWith('//') && currentTxn && !currentTxn.descripcion) {
          currentTxn.descripcion = l.substring(2).trim();
        }
      }
      if (currentTxn) transacciones.push(currentTxn);
      // Solo ingresos (créditos): monto positivo
      return transacciones.filter(t => t.monto > 0);
    },
    detectarCSVBancario(contenido) {
      const lineas = contenido.split(/\r?\n/).filter(l => l.trim());
      for (const linea of lineas.slice(0, 5)) {
        const campos = linea.trim().startsWith('"')
          ? linea.trim().slice(1, -1).split('","')
          : linea.trim().split(',');
        if (campos.length < 6) continue;
        const tipo = campos[5].trim();
        if (tipo === 'NC' || tipo === 'ND' || tipo === 'SI' || tipo === 'SF') return true;
      }
      return false;
    },
    parsearCSVBancario(contenido) {
      const transacciones = [];
      const lines = contenido.split(/\r?\n/).filter(l => l.trim());
      for (const line of lines) {
        const raw = line.trim();
        const campos = raw.startsWith('"')
          ? raw.slice(1, -1).split('","')
          : raw.split(',');
        if (campos.length < 8) continue;
        const tipo = campos[5].trim();
        if (tipo !== 'NC') continue; // Solo créditos / ingresos
        // Fecha DDMMYYYY → YYYY-MM-DD
        const fechaRaw = campos[3].trim();
        const fecha = fechaRaw.length === 8
          ? `${fechaRaw.substring(4)}-${fechaRaw.substring(2, 4)}-${fechaRaw.substring(0, 2)}`
          : fechaRaw;
        const descripcion = campos[6].trim();
        const referencia = campos[4].trim();
        // Monto: puede venir "1.557,36" o "-1.557,36" (Marzo usa negativos para ND)
        // Para NC siempre tomamos valor absoluto
        const montoRaw = campos[7].trim().replace(/\./g, '').replace(',', '.');
        const monto = Math.abs(parseFloat(parseFloat(montoRaw).toFixed(2)));
        if (isNaN(monto) || monto <= 0) continue;
        transacciones.push({ fecha, descripcion, monto, referencia, estatus: 'Pendiente' });
      }
      return transacciones;
    },
    detectarChase(contenido) {
      const primera = contenido.split(/\r?\n/).find(l => l.trim());
      if (!primera) return false;
      const h = primera.toLowerCase();
      return h.includes('posting date') && h.includes('details') && h.includes('amount') && h.includes('type');
    },
    parsearChase(contenido) {
      const transacciones = [];
      const lineas = contenido.split(/\r?\n/).filter(l => l.trim());
      if (lineas.length < 2) return transacciones;
      // Header: Details,Posting Date,Description,Amount,Type,Balance,Check or Slip #
      // Se limpian caracteres invisibles (BOM residual, espacios de no separación, zero-width)
      // que de lo contrario rompen la igualdad exacta de los nombres de columna.
      const header = lineas[0].split(',').map(c =>
        c.replace(/"/g, '').replace(/[\u200B\uFEFF\u00A0]/g, ' ').trim().toLowerCase()
      );
      let idxDetails = header.findIndex(h => h === 'details' || h.includes('details'));
      let idxFecha   = header.findIndex(h => h.includes('posting date') || h.includes('date'));
      let idxDesc    = header.findIndex(h => h === 'description' || h.includes('description'));
      let idxMonto   = header.findIndex(h => h === 'amount' || h.includes('amount'));
      // Fallback a las posiciones estándar de Chase si no se pudo identificar la columna por nombre
      if (idxDetails === -1) idxDetails = 0;
      if (idxFecha === -1) idxFecha = 1;
      if (idxDesc === -1) idxDesc = 2;
      if (idxMonto === -1) idxMonto = 3;

      this.chaseDebug = {
        headerRaw: lineas[0],
        header,
        idxDetails, idxFecha, idxDesc, idxMonto,
        totalLineas: lineas.length,
        primerasFilas: [],
      };

      for (let i = 1; i < lineas.length; i++) {
        // Parseo CSV respetando campos entre comillas y el escape estándar "" (comilla literal)
        const cols = [];
        let cur = '', inQ = false;
        let linea = lineas[i];
        // Algunos exports envuelven la fila COMPLETA en un par de comillas externas
        // (con las comillas internas de cada campo escapadas como ""). Si no se desenvuelve,
        // toda la línea se interpreta como un único campo entre comillas.
        if (linea.length >= 2 && linea[0] === '"' && linea[linea.length - 1] === '"') {
          linea = linea.slice(1, -1).replace(/""/g, '"');
        }
        for (let p = 0; p < linea.length; p++) {
          const ch = linea[p];
          if (ch === '"') {
            if (inQ && linea[p + 1] === '"') { cur += '"'; p++; } // comilla escapada ""
            else { inQ = !inQ; }
          } else if (ch === ',' && !inQ) {
            cols.push(cur.trim()); cur = '';
          } else {
            cur += ch;
          }
        }
        cols.push(cur.trim());
        if (this.chaseDebug.primerasFilas.length < 3) this.chaseDebug.primerasFilas.push(cols);
        if (cols.length < 4) continue;
        const details = (cols[idxDetails] || '').trim().toUpperCase();
        if (details !== 'CREDIT') continue;
        const monto = parseFloat((cols[idxMonto] || '').replace(/[^\d.]/g, ''));
        if (isNaN(monto) || monto <= 0) continue;
        // Fecha MM/DD/YYYY → YYYY-MM-DD
        const fechaRaw = (cols[idxFecha] || '').trim();
        const fp = fechaRaw.split('/');
        const fecha = fp.length === 3 ? `${fp[2]}-${fp[0].padStart(2,'0')}-${fp[1].padStart(2,'0')}` : fechaRaw;
        // Descripción completa
        const descFull = (cols[idxDesc] || '').trim();
        // Extraer nombre y referencia de "ZELLE PAYMENT FROM <NOMBRE> <REF>"
        const zelleMatch = descFull.match(/zelle\s+payment\s+from\s+(.+)/i);
        let descripcion = descFull;
        let referencia  = '';
        if (zelleMatch) {
          const resto = zelleMatch[1].trim();
          // El último token es el código de referencia (alfanumérico sin espacios)
          const tokens = resto.split(/\s+/);
          const lastToken = tokens[tokens.length - 1];
          if (/^[A-Z0-9]{8,}$/i.test(lastToken)) {
            referencia  = lastToken;
            descripcion = 'Zelle - ' + tokens.slice(0, -1).join(' ');
          } else {
            descripcion = 'Zelle - ' + resto;
            referencia  = '';
          }
        }
        if (!referencia) {
          // Intentar extraer una referencia genérica tipo "TRN: XXXX" (número de transacción de wires),
          // priorizando TRN sobre REF ya que REF suele preceder texto irrelevante en wires (ej. "REF: CHASE NYC/...")
          const refMatch = descFull.match(/\bTRN[:\s]+([A-Z0-9]{4,})/i) || descFull.match(/\bREF[:\s]+([A-Z0-9]{4,})/i);
          if (refMatch) referencia = refMatch[1];
        }
        if (!referencia) {
          // Último recurso: el último token alfanumérico de la descripción
          const tokens = descFull.split(/\s+/);
          const lastToken = tokens[tokens.length - 1];
          if (/^[A-Z0-9]{6,}$/i.test(lastToken)) referencia = lastToken;
        }
        if (!referencia) {
          // La API requiere referencia no vacía: se genera un identificador único por fila
          referencia = `CHASE-${fecha}-${i}`;
        }
        transacciones.push({ fecha, descripcion, monto, referencia, banco: 'Chase', estatus: 'Pendiente' });
      }
      return transacciones;
    },
    detectarBanescoSemicolon(contenido) {
      const lineas = contenido.split(/\r?\n/).filter(l => l.trim());
      if (lineas.length < 2) return false;
      const header = lineas[0].split(';').map(c => c.trim().toLowerCase());
      return header.some(h => h.includes('referencia')) &&
             header.some(h => h.includes('monto')) &&
             header.some(h => h.includes('fecha'));
    },
    parsearBanescoSemicolon(contenido) {
      const transacciones = [];
      const lineas = contenido.split(/\r?\n/).filter(l => l.trim());
      if (lineas.length < 2) return transacciones;
      // Detectar índices de columnas desde el encabezado
      const header = lineas[0].split(';').map(c => c.trim().toLowerCase());
      const idxFecha = header.findIndex(h => h.includes('fecha'));
      const idxRef   = header.findIndex(h => h.includes('referencia'));
      const idxDesc  = header.findIndex(h => h.includes('descripci'));
      const idxMonto = header.findIndex(h => h.includes('monto'));
      for (let i = 1; i < lineas.length; i++) {
        const cols = lineas[i].split(';').map(c => c.trim());
        if (cols.length < 4) continue;
        // Monto: "+72.000,00" o "-1.891,54" — quitar puntos de miles, reemplazar coma decimal
        const montoRaw = (cols[idxMonto] || '').replace(/\./g, '').replace(',', '.').replace('+', '');
        const monto = parseFloat(parseFloat(montoRaw).toFixed(2));
        if (isNaN(monto) || monto <= 0) continue; // Solo créditos
        // Fecha: "06/07/2026" → "2026-07-06"
        const fechaRaw = cols[idxFecha] || '';
        let fecha = fechaRaw;
        const partes = fechaRaw.split('/');
        if (partes.length === 3) fecha = `${partes[2]}-${partes[1]}-${partes[0]}`;
        const descripcion = (cols[idxDesc] || '').trim();
        const referencia  = (cols[idxRef]  || '').trim();
        transacciones.push({ fecha, descripcion, monto, referencia, estatus: 'Pendiente' });
      }
      return transacciones;
    },
    actualizarColumnas() {
      if (!this.rawRows || !this.rawRows.length) return;
      this.preview = this.rawRows.slice(0, 5);
      const primeraFila = this.rawRows[0] || [];
      if (this.primeraFilaEncabezado) {
        this.columnasOpciones = primeraFila.map((val, idx) => ({
          value: idx,
          text: val || 'Col ' + (idx + 1)
        }));
      } else {
        this.columnasOpciones = primeraFila.map((val, idx) => ({
          value: idx,
          text: `Col ${idx + 1}${val ? ': ' + String(val).substring(0, 25) : ''}`
        }));
      }
      this.mapeo = { fecha: null, descripcion: null, monto: null, referencia: null };
    },
    transform(date) {
      return this.$moment(date).utc().format("DD/MM/YYYY")
    },
    aplicarFiltros() {
      let filtroB = this.seleccionFiltroB;
      let filtroE = this.seleccionFiltro;

      // Reiniciar resultados
      this.resultados = [];
      this.dataExcel = [];
      
      // Filtrar resultados
      this.resultados = this.resultadosres.filter(el => {
        const cumpleFiltroB = (filtroB === "Todos" || el.banco === filtroB);
        const cumpleFiltroE = (filtroE === "todos" || el.estatus === filtroE);
        return cumpleFiltroB && cumpleFiltroE;
      });
      this.dataExcel = this.resultados.slice();
      for (let i = 0; i < this.dataExcel.length; i++) {
        let el = this.dataExcel[i];
        if (el.cobro && el.cobro.nro) {
          el.nro = el.cobro.nro
        } else el.nro = 'N/A'
      }
    },
    cambiarFiltroB() {
      this.aplicarFiltros();
    },
    cambiarFiltro() {
      this.aplicarFiltros();
    },
    verificacion() {
      for (let i = 0; i < this.$store.state.adminemanuel.permisos.length; i++) {
        if (this.$store.state.adminemanuel.permisos[i].ruta === "Movimientos") {
          for (
            let j = 0;
            j < this.$store.state.adminemanuel.permisos[i].accion.length;
            j++
          ) {
            if (
              this.$store.state.adminemanuel.permisos[i].accion[j] === "Crear"
            ) {
              this.cre = "yes";
            }
            if (
              this.$store.state.adminemanuel.permisos[i].accion[j] ===
              "Modificar"
            ) {
              this.mod = "yes";
            }
            if (
              this.$store.state.adminemanuel.permisos[i].accion[j] === "Eliminar"
            ) {
              this.elm = "yes";
            }
          }
        }
      }
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null
      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    buscarFecha() {
      this.dialog4 = true
      let hasta = (this.dates && this.dates[1]) ? this.dates[1] : null
      if (this.dates && this.dates[0]) {
        this.seleccionFiltro = 'todos'
        this.seleccionFiltroB = 'Todos'
        this.resultados = [];
        this.resultadosres = [];
        this.dataExcel = [];
        Api.get("movimientos/admin?desde="+this.dates[0]+'&hasta='+hasta)
        .then(res => {
          this.$nextTick(() => {
            if (res.data && res.data.length > 0) {
              for (let i = 0; i < res.data.length; i++) {
                const el = res.data[i];
                this.resultados.push(el)
                this.resultadosres.push(el)
                if (el.cobro && el.cobro.nro) {
                  el.nro = el.cobro.nro
                } else el.nro = 'N/A'
                this.dataExcel.push(el)
              }
            }
            this.dialog4 = false
          })
        }).catch(err=>{
          console.log(err)
          this.dialog4 = false
        })
      } else {
        this.$swal.fire(
          "¡Atención!",
          "Debes seleccionar al menos una fecha para realizar la operación",
          "error"
        );
      }
    },
    initialize() {
      this.date = new Date().toISOString().substr(0, 10)
      this.dateFormatted = this.formatDate(new Date().toISOString().substr(0, 10))
      this.dates = []
      let desde = this.$moment().subtract(1, "d").format('YYYY-MM-DD')
      let hasta = this.$moment().format('YYYY-MM-DD')
      this.dates.push(desde)
      this.dates.push(hasta)
      this.dialog4 = true;
      Api.get("movimientos/admin?desde="+this.dates[0]+'&hasta='+this.dates[1]).then(res => {
        this.resultados = [];
        this.resultadosres = [];
        this.dataExcel = [];
        if (res.data && res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            const el = res.data[i];
            this.resultados.push(el)
            this.resultadosres.push(el)
            if (el.cobro && el.cobro.nro) {
              el.nro = el.cobro.nro
            } else el.nro = 'N/A'
            this.dataExcel.push(el)
          }
        }
        this.dialog4 = false;
      }).catch(err=>{
        this.dialog4 = false;
        console.log(err)
      });
    },
    close() {
      this.form = Object.assign({}, this.defaultForm);
      this.data = [];
      this.banco = "";
      this.selectedFileName = "";
      this.rawRows = [];
      this.preview = [];
      this.columnasOpciones = [];
      this.mapeo = { fecha: null, descripcion: null, monto: null, referencia: null };
      this.esTxt = false;
      this.esMT940 = false;
      this.txtContenido = '';
      this.primeraFilaEncabezado = false;
      this.dialog = false;
    },
    editItem(item) {
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      this.form._id = item._id;
      this.dialog = true;
    },
    save() {
      if (!this.banco) {
        this.$swal.fire("¡Atención!", "Debe seleccionar un banco.", "error"); return;
      }
      // MT940: data ya está construida por el parser
      if (this.esMT940) {
        if (!this.data || this.data.length === 0) {
          this.$swal.fire("¡Atención!", "No se encontraron transacciones en el archivo MT940.", "error"); return;
        }
        this.data.forEach(el => {
          el.banco = this.banco;
          el.usuario = this.$store.state.adminemanuel._id;
        });
      } else {
        // Excel / TXT con mapeo
        if (!this.rawRows || this.rawRows.length === 0) {
          this.$swal.fire("¡Atención!", "Debe seleccionar un archivo.", "error"); return;
        }
        if (this.mapeo.fecha === null || this.mapeo.descripcion === null || this.mapeo.monto === null) {
          this.$swal.fire("¡Atención!", "Debe mapear al menos: Fecha, Descripción y Monto.", "error"); return;
        }
        const startRow = this.primeraFilaEncabezado ? 1 : 0;
        this.data = this.rawRows.slice(startRow)
          .filter(row => row.some(cell => cell && cell.toString().trim()))
          .map(row => ({
            fecha: row[this.mapeo.fecha] || '',
            descripcion: row[this.mapeo.descripcion] || '',
            monto: parseFloat(String(row[this.mapeo.monto] || '0').replace(/[^0-9.\-]/g, '')) || 0,
            referencia: this.mapeo.referencia !== null ? (row[this.mapeo.referencia] || '') : '',
            estatus: 'Pendiente',
            banco: this.banco,
            usuario: this.$store.state.adminemanuel._id
          }));
        if (this.data.length === 0) {
          this.$swal.fire("¡Atención!", "No hay filas de datos para procesar.", "error"); return;
        }
      }
      this.dialog4 = true;
      Api.post("movimientos", this.data)
        .then(() => {
          this.close();
          this.initialize();
          this.$swal.fire("Felicidades.!", "Movimientos cargados exitosamente.", "success");
        })
        .catch(err => {
          console.log(err);
          this.dialog4 = false;
          this.$swal.fire("Oops...", "Error encontrado, verifique los datos o llame al administrador.", "error");
        });
    }
  }
};
</script>
<style lang="scss">
</style>
